import { useQuery } from "@tanstack/react-query";
import { fetchPermissionsGroup } from "PFCore/services/admin/permissions_groups/fetch_permissions_group";
import { Id, PermissionsGroup, QueryOptions } from "PFTypes";

import { adminKeys } from "./query_keys";

export const usePermissionsGroup = (id: Id, options: QueryOptions<PermissionsGroup> = {}) => {
  const queryKey = adminKeys.permissionsGroupsPage(id);

  return useQuery<PermissionsGroup>({
    queryKey,
    queryFn: () => fetchPermissionsGroup(id),
    ...options
  });
};
